export default "__VITE_ASSET__de4842d0__"